import { SB } from '@play-co/replicant';

export default {
  gifts: SB.object({
    // List of sent gifts
    sent: SB.map(
      // Sent gifts list, key is target user id
      SB.object({
        // When message was sent last time
        sentAt: SB.int(),
        // Streaks counter
        streaks: SB.int().optional(),
      }),
    ),

    // List of received gifts with user ID key
    received: SB.map(
      // Gift model
      SB.object({
        // How many energy we should give
        energy: SB.int().min(0).optional(),
        // How many bPoints we should give
        bPoints: SB.int().min(0).optional(),
        // How many bPoints we should give
        gems: SB.int().min(0).optional(),
        // When was message sent
        sentAt: SB.int(),
        // Streaks counter
        streaks: SB.int().optional(),
      }),
    ),

    // Count of batched gifts.
    giftBatchCount: SB.int(),

    // Gems collected from friend gifts on the JST day of collectedAt
    collected: SB.object({
      gems: SB.int().min(0),
      collectedAt: SB.int(),
    }),
  }),

  /** @deprecated Gifting Season event removed (#10057). Kept for existing user state. */
  giftingEvents: SB.object({
    /** @deprecated Gifting Season event removed (#10057) */
    giftingSeason: SB.object({
      // event timestamp
      startedAt: SB.number(),
      // number of total gift sent during the event
      giftSentCount: SB.number(),
      // event completion status
      completed: SB.boolean(),
      // metrics for calculating milestones
      startedTotalFriends: SB.number(),
      startedInactiveFriends: SB.number(),
    }).optional(),
  }).optional(),
};
